// Page « Mot de passe oublié » : demande un lien de réinitialisation.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatErreur } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [erreur, setErreur] = useState("");
  const [envoye, setEnvoye] = useState(false);
  const [chargement, setChargement] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    setChargement(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setEnvoye(true);
    } catch (err) {
      setErreur(formatErreur(err.response?.data?.detail));
    } finally {
      setChargement(false);
    }
  };

  return (
    <AuthLayout
      titre="Mot de passe oublié"
      sousTitre="Saisissez votre email pour recevoir un lien de réinitialisation."
    >
      {envoye ? (
        <div data-testid="message-confirmation" className="rounded-md bg-[#E8F4F4] border border-[#4A8A8A]/30 px-4 py-5 text-[#1D3D3D]">
          <CheckCircle2 className="h-6 w-6 text-[#4A8A8A] mb-2" />
          <p className="text-sm">
            Si cet email existe, un lien de réinitialisation vient d'être envoyé.
            Vérifiez votre boîte de réception.
          </p>
          <Link to="/login" className="inline-block mt-4 text-sm text-[#4A8A8A] hover:text-[#2D5A5A] font-semibold">
            ← Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={soumettre} className="space-y-5" data-testid="formulaire-oubli">
          {erreur && (
            <div data-testid="message-erreur" className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
              {erreur}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-[#1D3D3D] font-semibold">Adresse email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A8A8A]" />
              <Input id="email" type="email" data-testid="champ-email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="vous@entreprise.pf" required
                className="pl-10 bg-white border-[#4A8A8A]/30 focus-visible:ring-[#4A8A8A]" />
            </div>
          </div>
          <Button type="submit" data-testid="bouton-envoyer-lien" disabled={chargement}
            className="w-full bg-[#1D3D3D] hover:bg-[#2D5A5A] text-white font-semibold h-11">
            {chargement ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
          </Button>
          <p className="text-center text-sm text-[#1D3D3D]/70">
            <Link to="/login" className="text-[#4A8A8A] hover:text-[#2D5A5A] font-semibold">
              Retour à la connexion
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
